// src/lib/clearCachesOnce.ts
export async function clearCachesOnce() {
  if (!("caches" in window)) return;

  const key = "canxp_cache_cleared_v2";
  if (localStorage.getItem(key)) return;

  const names = await caches.keys();
  await Promise.all(names.map(n => caches.delete(n)));

  localStorage.setItem(key, "1");
  console.log("[CacheGuard] Cleared all caches (one-time)");
}
